import { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../../../components/button'
import { Input } from '../../../../components/input'
import { PageContainer } from '../../../../components/page-container/page-container'
import { showToast } from '../../../../components/sonner'
import type { RootState } from '../../../../redux/global-store'
import { paths } from '../../../../router/paths'
import { createJourneyRequest } from '../../presentation/redux/actions/journey-actions'

export const JourneyInput = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [numeroEmpleado, setNumeroEmpleado] = useState('')
  const [codigoRuta, setCodigoRuta] = useState('')

  // Journey state
  const { journey, load, error } = useSelector(
    (state: RootState) => state.journey.journey,
  )

  // User state para pegar userId
  const { user } = useSelector(
    (state: RootState) => state.auth.login,
  )

  const handleCreateJourney = () => {
    if (numeroEmpleado.trim() && codigoRuta.trim() && user) {
      dispatch(createJourneyRequest({
        UserId: user.userId,
        Route: codigoRuta,
        EmployeeNumber: user.userId.toString(), // TODO: Usar campo employeeNumber quando implementado
      }))
    }
  }

  // Navigate to home when journey is created successfully
  useEffect(() => {
    if (journey && !load) {
      navigate(paths.home)
    }
  }, [journey, load, navigate])

  // Show error message if journey creation fails
  useEffect(() => {
    if (error) {
      showToast(error, 'error')
    }
  }, [error])

  return (
    <PageContainer type="unauthenticated">
      <div className="flex w-full flex-col items-center justify-between gap-8 px-8 py-16">
        <div className="flex flex-col items-center gap-6">
          <h1 className="text-2xl font-medium">Bienvenido a DASH</h1>
        </div>
        <div className="flex w-full flex-col items-center gap-4">
          <Input
            value={numeroEmpleado}
            onChange={(e) => setNumeroEmpleado(e.target.value)}
            placeholder="Número de empleado"
            label="Número de empleado"
          />
          <Input
            value={codigoRuta}
            onChange={(e) => setCodigoRuta(e.target.value)}
            placeholder="Código de ruta"
            label="Código de ruta"
          />
          <Button
            className="w-full max-w-[380px] rounded-[5px] text-2xl font-medium"
            onClick={handleCreateJourney}
            disabled={!numeroEmpleado.trim() || !codigoRuta.trim()}
          >
            Ingresar
          </Button>
        </div>
      </div>
    </PageContainer>
  )
}